import { Trajectory } from "./Trajectory.js";
import Flatten from '@flatten-js/core';
import { V } from "../misc/Vector.js";
import { GeometryUtils as G } from '../utils/Geometry.js';
export { FullTrajectory };
class FullTrajectory extends Trajectory {
    constructor({ tangents, waypoint, center, radius, width, spacing, connection }) {
        super({ waypoint, center, radius, width, spacing, connection });
        this.tangents = tangents;
    }
    getOtherTangent(tangent) {
        if (tangent === this.tangents[0]) {
            return this.tangents[1];
        }
        else if (tangent === this.tangents[1]) {
            return this.tangents[0];
        }
        else {
            throw new Error('Invalid');
        }
    }
    getTangentTo(trajectory) {
        if ((this.tangents[0].isSource(this) && this.tangents[0].isTarget(trajectory)) || this.tangents[0].isSource(trajectory) && this.tangents[0].isTarget(this)) {
            return this.tangents[0];
        }
        else if ((this.tangents[1].isSource(this) && this.tangents[1].isTarget(trajectory)) || this.tangents[1].isSource(trajectory) && this.tangents[1].isTarget(this)) {
            return this.tangents[1];
        }
        else {
            throw new Error('Invalid');
        }
    }
    clone() {
        return new FullTrajectory({
            tangents: [...this.tangents],
            waypoint: this.waypoint,
            center: this.center,
            radius: this.radius,
            width: this.width,
            spacing: this.spacing,
            connection: this.connection
        });
    }
    getAngles() {
        const vA = V.subtract(this.tangents[0].getPoint(this), this.center);
        const vB = V.subtract(this.tangents[1].getPoint(this), this.center);
        if (this.tangents[0].getReverseRotation(this) > 0) {
            return [
                Math.atan2(vA[1], vA[0]),
                Math.atan2(vB[1], vB[0])
            ];
        }
        else {
            return [
                Math.atan2(vB[1], vB[0]),
                Math.atan2(vA[1], vA[0])
            ];
        }
    }
    getArc() {
        const vA = V.subtract(this.tangents[0].getPoint(this), this.center);
        const vB = V.subtract(this.tangents[1].getPoint(this), this.center);
        return new Flatten.Arc(new Flatten.Point(this.center[0], this.center[1]), this.radius, G.normalizedAngle(vA), G.normalizedAngle(vB), this.tangents[0].getReverseRotation(this) > 0);
    }
    intersects(pointA, pointB) {
        const EPSILON = 1e-6;
        if (V.distance(pointA, pointB) < EPSILON) {
            return false;
        }
        const segment = new Flatten.Segment(new Flatten.Point(pointA[0], pointA[1]), new Flatten.Point(pointB[0], pointB[1]));
        const arc = this.getArc();
        const tangentA = new Flatten.Segment(new Flatten.Point(this.tangents[0].sourcePoint[0], this.tangents[0].sourcePoint[1]), new Flatten.Point(this.tangents[0].targetPoint[0], this.tangents[0].targetPoint[1]));
        const tangentB = new Flatten.Segment(new Flatten.Point(this.tangents[1].sourcePoint[0], this.tangents[1].sourcePoint[1]), new Flatten.Point(this.tangents[1].targetPoint[0], this.tangents[1].targetPoint[1]));
        return segment.intersect(arc).length !== 0 || segment.intersect(tangentA).length !== 0 || segment.intersect(tangentB).length !== 0;
    }
    arcIntersects(arc) {
        if (arc instanceof Flatten.Point) {
            return false;
        }
        const EPSILON = 1e-6;
        if (arc.length < EPSILON) {
            return false;
        }
        const trajectoryArc = this.getArc();
        const tangentA = new Flatten.Segment(new Flatten.Point(this.tangents[0].sourcePoint[0], this.tangents[0].sourcePoint[1]), new Flatten.Point(this.tangents[0].targetPoint[0], this.tangents[0].targetPoint[1]));
        const tangentB = new Flatten.Segment(new Flatten.Point(this.tangents[1].sourcePoint[0], this.tangents[1].sourcePoint[1]), new Flatten.Point(this.tangents[1].targetPoint[0], this.tangents[1].targetPoint[1]));
        return arc.intersect(trajectoryArc).length !== 0 || arc.intersect(tangentA).length !== 0 || arc.intersect(tangentB).length !== 0;
    }
    getTangents() {
        return [...this.tangents];
    }
}
//# sourceMappingURL=FullTrajectory.js.map